<template>
	<div class="mb-16 h-full">
		<calendar-view
			:show-date="showDate"
			:events="items"
			class="theme-default holiday-us-traditional holiday-us-official">
				<calendar-view-header
					slot="header"
					slot-scope="t"
					:header-props="t.headerProps"
					@input="setShowDate"
				></calendar-view-header>
		</calendar-view>
	</div>
</template>

<script>
	import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
	
	import "vue-simple-calendar/static/css/holidays-us.css"

	export default {
	    name: 'ReoptCalendar',

		data() {
			return {
				showDate: new Date(),
				items: [
					{
						'startDate': '2020-02-21',
						'title': 'Test Event'
					}
				]
			}
		},

		components: {
			CalendarView,
			CalendarViewHeader,
		},

		methods: {
			setShowDate(d) {
				this.showDate = d;
			},
		}
	}
</script>